import AbstractListView from './AbstractListingView';

import ContentTypeSwitch from "components/ContentTypeSwitch";

export default class FullView extends AbstractListView {
    render() {
        const children = this.state.children.map(child => {
            return (
                <ContentTypeSwitch item={ child } />
            );
        });

        return (
            <article>
                { !this.props.hideSelf && <h1>{ this.props.item.title }</h1> }
                { children }
            </article>
        )
    }
}


// WEBPACK FOOTER //
// ./components/ContentViews/FullView.jsx